const Status = {
    Pending : "Pending",
    Complete : "Complete",
    Reject : "Reject"
}

export default Status